import { useMouseInputs } from 'app/agriculture/forms/components/ShapeEditor/hooks/useMouseInputs';
import { useKeyboardInputs } from 'app/agriculture/forms/components/ShapeEditor/hooks/useKeyboardInputs';

export function ShapeEditorInputHandlers() {
    useMouseInputs();
    useKeyboardInputs();

    return null;
}
